import BrightcoveVideoPlayer from "@components/Player/BrightcoveVideoPlayer";
import useBrightcovePlayerId from "@hooks/useBrightcovePlayerId";
import { Type } from "@typings/enums";
import { BT_BRIGHTCOVE_ACCOUNT_ID } from "@util/constant";

export type BrightcoveVideoProps = {
  /** The Brightcove video ID to be played.*/
  videoId: string;
  /** Optional CSS class to apply to the video container. */
  className?: string;
};

/**
 * BrightcoveVideo component that renders a Brightcove video player.
 */
const BrightcoveVideo = ({
  className,
  videoId,
}: BrightcoveVideoProps): React.ReactElement => {
  const playerId = useBrightcovePlayerId();

  if (!videoId) return <></>;
  if (typeof playerId === "undefined") return <></>;

  return (
    <div
      className={className}
      data-story-element={Type.BrightcoveVideo}
      data-testid="brightcove-video-component"
    >
      <BrightcoveVideoPlayer
        videoId={videoId}
        accountId={BT_BRIGHTCOVE_ACCOUNT_ID}
        playerId={playerId}
      />
    </div>
  );
};

export default BrightcoveVideo;
